import * as React from 'react'

const SvgSunglasses = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={170}
    height={90}
    viewBox="0 0 170 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#Sunglasses_svg__a)">
      <path
        d="m146.017 19.2-91.1 21.148a29.797 29.797 0 0 0-18.252 12.82L17.997 81.959c-2.544 3.92.965 8.952 5.499 7.9 9.755-2.266 17.814-9.141 21.616-18.443l4.218-10.321a11.14 11.14 0 0 1 8.697-6.82l92.928-13.616-4.938-21.454V19.2Z"
        fill="#7130C9"
      />
      <path
        d="m22.076 19.2 91.1 21.148a29.795 29.795 0 0 1 18.252 12.82l18.668 28.791c2.544 3.92-.964 8.952-5.498 7.9-9.756-2.266-17.815-9.141-21.617-18.443l-4.218-10.321a11.14 11.14 0 0 0-8.696-6.82L17.137 40.66l4.94-21.454V19.2Z"
        fill="#440A78"
      />
      <path
        d="M53.298 16.305H26.084c-10.58 0-19.156 8.614-19.156 19.239v10.382c0 10.625 8.577 19.239 19.156 19.239h27.214c10.58 0 19.156-8.614 19.156-19.24V35.545c0-10.625-8.576-19.239-19.155-19.239Z"
        fill="#440A78"
      />
      <path
        d="M138.412 12.687h-27.209c-10.514 0-19.377 7.198-21.982 16.94a14.934 14.934 0 0 0-8.636-2.745c-3.209 0-6.185 1.019-8.635 2.744-2.605-9.741-11.468-16.94-21.983-16.94H22.758C10.21 12.687 0 22.942 0 35.545v10.382c0 12.603 10.21 22.857 22.758 22.857h27.21c12.548 0 22.758-10.254 22.758-22.857v-3.913c0-4.354 3.525-7.889 7.854-7.889 4.329 0 7.854 3.54 7.854 7.889v3.913c0 12.603 10.21 22.857 22.758 22.857h27.209c12.549 0 22.758-10.254 22.758-22.857V35.544c0-12.603-10.209-22.857-22.758-22.857h.011ZM65.526 45.926c0 8.612-6.978 15.62-15.553 15.62h-27.21c-8.574 0-15.552-7.008-15.552-15.62V35.544c0-8.612 6.978-15.62 15.553-15.62h27.209c8.575 0 15.553 7.008 15.553 15.62v10.382Zm88.445 0c0 8.612-6.979 15.62-15.553 15.62h-27.209c-8.575 0-15.553-7.008-15.553-15.62V35.544c0-8.612 6.978-15.62 15.553-15.62h27.209c8.574 0 15.553 7.008 15.553 15.62v10.382Z"
        fill="#7130C9"
      />
      <path
        d="M141.743 16.305h-27.214c-10.58 0-19.156 8.614-19.156 19.239v10.382c0 10.625 8.576 19.239 19.156 19.239h27.214c10.58 0 19.156-8.614 19.156-19.24V35.545c0-10.625-8.576-19.239-19.156-19.239Z"
        fill="#440A78"
      />
      <path
        d="M141.738 12.687h-27.209c-10.515 0-19.378 7.197-21.983 16.94a14.934 14.934 0 0 0-8.635-2.745c-3.21 0-6.186 1.019-8.636 2.744-2.605-9.742-11.468-16.94-21.982-16.94h-27.21c-12.548 0-22.758 10.255-22.758 22.858v10.382c0 12.603 10.21 22.857 22.759 22.857h27.209c12.548 0 22.758-10.254 22.758-22.857v-3.914c0-4.353 3.525-7.888 7.854-7.888 4.329 0 7.854 3.54 7.854 7.888v3.914c0 12.603 10.21 22.857 22.758 22.857h27.209c12.549 0 22.759-10.254 22.759-22.857V35.544c0-12.603-10.21-22.857-22.759-22.857h.012ZM68.851 45.926c0 8.612-6.978 15.62-15.553 15.62H26.09c-8.574 0-15.552-7.008-15.552-15.62V35.544c0-8.612 6.978-15.62 15.552-15.62H53.3c8.574 0 15.552 7.008 15.552 15.62v10.382Zm88.445 0c0 8.612-6.978 15.62-15.553 15.62h-27.209c-8.574 0-15.553-7.008-15.553-15.62V35.544c0-8.612 6.979-15.62 15.553-15.62h27.209c8.575 0 15.553 7.008 15.553 15.62v10.382Z"
        fill="#9865FC"
      />
      <path
        d="m20.48 47.885 40.4-16.071-38.81 19.628c-2.433 1.12-4.046-2.471-1.59-3.557ZM107.539 47.885l40.401-16.071-38.81 19.628c-2.433 1.12-4.046-2.471-1.591-3.557Z"
        fill="#E1CEFF"
      />
      <path
        d="M160.988 9.052 170 12.759l-9.012 3.713-3.692 9.052-3.697-9.052-9.012-3.713 9.012-3.707L157.296 0l3.692 9.052Z"
        fill="#FFC103"
      />
    </g>
    <defs>
      <clipPath id="Sunglasses_svg__a">
        <path fill="#fff" d="M0 0h170v90H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgSunglasses
